/* unplugin-vue-components disabled */import { render } from "./Support.vue?vue&type=template&id=54dfd486"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"

import "./Support.vue?vue&type=style&index=0&id=54dfd486&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__